var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isBlankLayoutRoute)?_c('Header'):_vm._e(),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1),(!_vm.isBlankLayoutRoute)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }